import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Table, Input, Badge } from "reactstrap";

// Inventario Full: compara el almacen Full de Cuory (el "Almacen Full" de las
// cuentas) contra lo que Mercado Libre tiene en sus bodegas, y lo cuadra con
// un ajuste de inventario autorizado. Solo lee de Meli.
function FullMeli({ URL, headers, cuentas, areas, error }) {
  // Almacenes que alguna cuenta usa como Full
  const idsFull = [...new Set(cuentas.filter((c) => c.plataforma === "Mercado Libre" && c.areaFull).map((c) => String(c.areaFull)))];
  const opciones = areas.filter((a) => idsFull.includes(String(a._id)));
  const [area, setArea] = useState("");
  const [datos, setDatos] = useState(null);
  const [elegidos, setElegidos] = useState({});
  const [soloDiferencias, setSoloDiferencias] = useState(true);
  const [busca, setBusca] = useState("");
  const [trabajando, setTrabajando] = useState("");

  useEffect(() => {
    if (!area && opciones.length) setArea(opciones[0]._id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuentas, areas]);

  function compara() {
    setTrabajando("Leyendo Mercado Libre...");
    axios
      .get(`${URL}Full?area=${area}`, { headers })
      .then((res) => {
        setTrabajando("");
        setDatos(res.data);
        setElegidos({});
      })
      .catch((e) => {
        setTrabajando("");
        error(e, "No se pudo comparar");
      });
  }

  function ajusta(articulos) {
    const filas = articulos ? datos.filas.filter((f) => articulos.includes(f.articulo)) : datos.filas.filter((f) => f.diferencia !== 0);
    const entran = filas.filter((f) => f.diferencia > 0).reduce((t, f) => t + f.diferencia, 0);
    const salen = filas.filter((f) => f.diferencia < 0).reduce((t, f) => t - f.diferencia, 0);
    Swal.fire({
      title: `Cuadrar ${datos.area.name} con Mercado Libre`,
      html: `<div style="text-align:left;font-size:14px">
        Se hace <b>un ajuste de inventario autorizado</b> con ${filas.length} articulos:
        <br>+${entran.toLocaleString("en-US")} pzs que estan en Meli y faltan en Cuory
        <br>−${salen.toLocaleString("en-US")} pzs que estan en Cuory y Meli ya no tiene
        <br><br><span style="color:#64748b">Antes de ajustar se vuelve a leer Meli, por si algo cambio.</span></div>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ajustar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      setTrabajando("Ajustando...");
      axios
        .post(`${URL}FullAjuste`, { area, articulos: articulos || undefined }, { headers })
        .then((res) => {
          setTrabajando("");
          const d = res.data || {};
          Swal.fire({
            icon: "success",
            title: d.ajuste ? `Ajuste ${d.ajuste}` : "Sin cambios",
            text: d.ajuste ? `${d.articulos} articulos, neto ${d.piezas > 0 ? "+" : ""}${d.piezas} pzs` : d.mensaje,
          });
          compara();
        })
        .catch((e) => {
          setTrabajando("");
          error(e, "No se pudo ajustar");
        });
    });
  }

  if (!opciones.length) {
    return (
      <div style={{ fontSize: 13, color: "#94a3b8" }}>
        Ninguna cuenta de Mercado Libre tiene "Almacen Full". Eligelo en la pestana Cuentas.
      </div>
    );
  }

  const q = busca.trim().toLowerCase();
  const filas = datos
    ? datos.filas.filter(
        (f) => (!soloDiferencias || f.diferencia !== 0) && (!q || f.SKU.toLowerCase().includes(q) || f.nombre.toLowerCase().includes(q))
      )
    : [];
  const ids = Object.keys(elegidos).filter((k) => elegidos[k]);
  const r = datos && datos.resumen;
  const nombresCuentas = datos ? datos.cuentas : [];

  return (
    <>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 10 }}>
        <div>
          <div style={{ fontSize: 12, color: "#64748b" }}>Almacen Full</div>
          <Input bsSize="sm" type="select" value={area} onChange={(e) => (setArea(e.target.value), setDatos(null))} style={{ width: 240 }}>
            {opciones.map((a) => (
              <option key={a._id} value={a._id}>
                {a.name}
              </option>
            ))}
          </Input>
        </div>
        <Button size="sm" color="info" disabled={!!trabajando} onClick={compara}>
          <i class="fas fa-balance-scale"></i> {trabajando || "Comparar con Mercado Libre"}
        </Button>
        {datos ? (
          <>
            <Button size="sm" color="success" disabled={!!trabajando || !ids.length} onClick={() => ajusta(ids)}>
              Ajustar elegidos ({ids.length})
            </Button>
            <Button size="sm" color="warning" disabled={!!trabajando || !r.conDiferencia || !r.lecturaCompleta} onClick={() => ajusta(null)}>
              Ajustar todo ({r.conDiferencia})
            </Button>
          </>
        ) : null}
      </div>
      {trabajando === "Leyendo Mercado Libre..." ? (
        <div style={{ fontSize: 12, color: "#64748b", marginBottom: 8 }}>Se lee el stock de cada producto en Full; puede tardar uno o dos minutos.</div>
      ) : null}

      {r ? (
        <>
          <div style={{ fontSize: 12, color: "#475569", marginBottom: 6 }}>
            Cuentas: <b>{nombresCuentas.join(", ")}</b> · leido {new Date(datos.leido).toLocaleString("es-MX", { dateStyle: "short", timeStyle: "short" })}
          </div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
            <Badge color="dark" pill>Meli: {r.piezasMeli.toLocaleString("en-US")} pzs</Badge>
            <Badge color="primary" pill>Cuory: {r.piezasCuory.toLocaleString("en-US")} pzs</Badge>
            <Badge color={r.conDiferencia ? "warning" : "success"} pill>{r.conDiferencia} articulos con diferencia de {r.articulos}</Badge>
            {r.faltanEnCuory ? <Badge color="info" pill>+{r.faltanEnCuory.toLocaleString("en-US")} faltan en Cuory</Badge> : null}
            {r.sobranEnCuory ? <Badge color="danger" pill>−{r.sobranEnCuory.toLocaleString("en-US")} sobran en Cuory</Badge> : null}
            {r.sinAmarrar ? (
              <Badge color="danger" pill>
                {r.sinAmarrar} productos en Full sin articulo ({r.piezasSinAmarrar} pzs)
              </Badge>
            ) : null}
            {!r.lecturaCompleta ? <Badge color="danger" pill>Lectura incompleta: no se puede ajustar todo</Badge> : null}
          </div>
          {datos.errores && datos.errores.length ? (
            <div style={{ fontSize: 11, color: "#b91c1c", marginBottom: 8 }}>{datos.errores.join(" · ")}</div>
          ) : null}
          {datos.sinAmarrar.length ? (
            <div style={{ background: "#fef2f2", borderRadius: 8, padding: 8, marginBottom: 10, fontSize: 12 }}>
              <b>En Full pero sin articulo en Cuory</b> (no entran al ajuste; amarralos en la pestana Publicaciones o da de alta el articulo):
              {datos.sinAmarrar.map((s) => (
                <div key={s.cuenta + s.up}>
                  {s.cuenta} · {s.sku || "sin SKU"} · {s.titulo}
                  {s.variacion ? ` (${s.variacion})` : ""} · <b>{s.piezas} pzs</b> · {s.publicaciones.join(", ")}
                </div>
              ))}
            </div>
          ) : null}
          <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 6 }}>
            <Input bsSize="sm" placeholder="Buscar SKU o nombre" value={busca} onChange={(e) => setBusca(e.target.value)} style={{ width: 240 }} />
            <label style={{ fontSize: 13, cursor: "pointer", marginBottom: 0 }}>
              <input type="checkbox" checked={soloDiferencias} onChange={(e) => setSoloDiferencias(e.currentTarget.checked)} style={{ marginRight: 4 }} />
              Solo con diferencia
            </label>
            <span style={{ fontSize: 12, color: "#64748b" }}>{filas.length} articulos</span>
          </div>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={filas.some((f) => f.diferencia !== 0) && filas.filter((f) => f.diferencia !== 0).every((f) => elegidos[f.articulo])}
                    onChange={(e) => {
                      const v = e.currentTarget.checked;
                      const n = {};
                      filas.filter((f) => f.diferencia !== 0).forEach((f) => (n[f.articulo] = v));
                      setElegidos(n);
                    }}
                  />
                </th>
                <th>SKU</th>
                <th>Articulo</th>
                {nombresCuentas.map((n) => (
                  <th key={n} className="text-right">
                    {n}
                  </th>
                ))}
                <th className="text-right">Meli total</th>
                <th className="text-right">Cuory</th>
                <th className="text-right">Diferencia</th>
              </tr>
            </thead>
            <tbody>
              {filas.slice(0, 1500).map((f) => (
                <tr key={f.articulo}>
                  <td>
                    <input
                      type="checkbox"
                      disabled={f.diferencia === 0}
                      checked={!!elegidos[f.articulo]}
                      onChange={(e) => setElegidos({ ...elegidos, [f.articulo]: e.currentTarget.checked })}
                    />
                  </td>
                  <td style={{ fontSize: 12 }}>{f.SKU}</td>
                  <td style={{ fontSize: 12, maxWidth: 320 }}>{f.nombre}</td>
                  {nombresCuentas.map((n) => (
                    <td key={n} className="text-right" style={{ color: f.porCuenta[n] ? undefined : "#cbd5e1" }}>
                      {(f.porCuenta[n] || 0).toLocaleString("en-US")}
                    </td>
                  ))}
                  <td className="text-right">
                    <b>{f.meli.toLocaleString("en-US")}</b>
                  </td>
                  <td className="text-right">{f.cuory.toLocaleString("en-US")}</td>
                  <td className="text-right" style={{ color: f.diferencia > 0 ? "#15803d" : f.diferencia < 0 ? "#b91c1c" : "#94a3b8" }}>
                    {f.diferencia > 0 ? `+${f.diferencia.toLocaleString("en-US")}` : f.diferencia.toLocaleString("en-US")}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <div style={{ fontSize: 13, color: "#64748b" }}>
          Compara lo que Cuory tiene en el almacen Full contra lo que Mercado Libre tiene en sus bodegas (todas las cuentas que usan ese almacen).
          No escribe nada en Mercado Libre; el ajuste solo mueve el inventario de Cuory.
        </div>
      )}
    </>
  );
}

export default FullMeli;
